import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;

	img {
		position: absolute;
		right: 20px;
		top: 50%;
		transform: translateY(-50%);
		width: 20px;
		height: 20px;
		opacity: 0.5;
		user-select: none;
		pointer-events: none;
		transition:
			opacity 0.3s ease,
			filter 0.3s ease;
	}

	&:hover {
		img {
			opacity: 1;
			filter: invert(1);
		}
	}
`;

export { StyledContainer };
